import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      
      {/* Page Header Banner */}
      <header className="bg-slate-900 pt-12 pb-20 border-b-4 border-yellow-400">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-yellow-400 hover:text-yellow-300 mb-6 font-medium transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight">
            About This Service
          </h1>
        </div>
      </header>

      {/* Main Content Area with Overlap Effect */}
      <main className="flex-grow max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 -mt-10 mb-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-10 md:p-12">
          
          {/* Section 1: The Context */}
          <div className="mb-10 text-gray-700 text-lg leading-relaxed">
            <p>
              Incidences of vehicle theft are reported to the Nigeria Police Force
              for investigation that would lead to the recovery of such vehicles,
              apprehension and prosecution of the offenders. Some of the stolen
              vehicles end up not being recovered and the perpetrators end up
              escaping the long arms of the law. This tends to encourage the
              continued indulgence in the unwholesome activity and attracting
              other criminally-minded persons to engage in it.
            </p>
          </div>

          {/* Section 2: The Solution (Highlighted Block) */}
          <div className="mb-10 bg-blue-50/80 border-l-4 border-blue-600 p-6 sm:p-8 rounded-r-xl">
            <h3 className="text-xl font-bold text-slate-900 mb-3 flex items-center">
              <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              The NPF Digital CMR Initiative
            </h3>
            <p className="text-gray-800 text-lg leading-relaxed">
              The Nigeria Police Force in its determined effort to protect the
              properties of citizens in Nigeria, created this website to enable
              members of the public report their vehicles that were stolen from
              <strong> 1st January 2018 </strong> and yet to be recovered. It is a 
              <span className="font-semibold text-blue-700"> free service </span> 
              and a precursor to the transition of the current method of registering
              vehicles by the Nigeria Police Central Motor Registry (CMR) to a
              digitized mode with the aim of checkmating and preventing the
              registration of such stolen vehicles.
            </p>
          </div>

          {/* Section 3: The Timeline / Notice */}
          <div className="bg-amber-50 border border-amber-200 p-6 sm:p-8 rounded-xl">
            <div className="flex items-start">
              <svg className="w-8 h-8 text-amber-500 mr-4 shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <h3 className="text-lg font-bold text-amber-900 mb-2">
                  Service Window & Deadline
                </h3>
                <p className="text-amber-800 text-lg leading-relaxed">
                  This service is available up till <strong>31st of December 2022</strong> as the
                  modernized CMR including its e-enforcement operations will commence
                  on 1st December 2022. Members of the public are therefore enjoined
                  to seize this window of opportunity to report the theft of their
                  vehicle which are yet to be recovered and support the Nigeria Police
                  Force efforts at enhancing national security.
                </p>
              </div>
            </div>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}